import { z } from 'zod';
import { LeadEventKindSchema } from '../enums/lead-event-kind.js';
import { IsoDateStringSchema, UuidV7Schema } from './common.js';

/**
 * Événement métier d'un lead — ligne immutable de la table `lead_events`.
 * La timeline du LeadDetail lit directement cette liste.
 */
export const LeadEventSchema = z.object({
  id: UuidV7Schema,
  leadId: UuidV7Schema,
  kind: LeadEventKindSchema,
  fromValue: z.string().nullable().optional(),
  toValue: z.string().nullable().optional(),
  actorUserId: UuidV7Schema.nullable().optional(),
  /** Si true, n'est rendu que pour les admins (cf. AnonymizeInterceptor). */
  adminOnly: z.boolean(),
  meta: z.record(z.unknown()).nullable().optional(),
  createdAt: IsoDateStringSchema,
});
export type LeadEvent = z.infer<typeof LeadEventSchema>;
